import { useEffect, useState } from "react";
import AppButton from "../../components/AppButton/AppButton";
import PageHeader from "../../PageHeader/PageHeader";
import { useNavigate } from "react-router-dom";
import { Loader, PenLine, Trash } from "lucide-react";
import { HitApi } from "../../Api/ApiHit.js";
import { deleteSurvey, searchSurvey, updateSurvey } from "../../constant/Constant.js";
import { useDispatch, useSelector } from "react-redux";
import { setDataAction } from "../../redux/Actions/SetDataAction.js";
import toast from "react-hot-toast";
import { SelectedQuestion } from "../../components/ToggelSwitch/ToggelSwitch.js";
import { SET_SURVEY_DATA } from "../../redux/ActionName/ActionName.js";

const Survey = () => {
  let [loading, setLoading] = useState(false)
  const SurveyData = useSelector(state => state.CreateSurvey)
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch()

  useEffect(() => {
    loadServey()
  }, [])

  const loadServey = () => {

    const json = { page: 1, limit: 10, search: {} }
    HitApi(json, searchSurvey).then((res) => {
      console.log("res--", res.data);
      setLoading(false)
      if (res?.statusCode === 200) {
        dispatch(setDataAction(res?.data, SET_SURVEY_DATA))
      }
    })
  }
  const handelDelete = (id) => {
    const json = { _id: id }
    HitApi(json, deleteSurvey).then((res) => {
      console.log("res", res);
      if (res.statusCode === 204) {
        toast.success("Record Deleted Successfully")
        loadServey()
      }
    })
  }
  const handleToggle = (groupIndex, id, selected) => {
    setLoading(id)
    let oldData = [...SurveyData?.selectedSurvey]
    const json = { question: oldData[groupIndex]?.questions, selected: !selected, _id: id }
    HitApi(json, updateSurvey).then((res) => {
      console.log("res---", res);
      loadServey()
    })
    setActiveIndex((prev) => (prev === groupIndex ? null : groupIndex));
  };



  console.log("SurveyData---bejo", SurveyData?.selectedSurvey);


  return (
    <div>
      <div className="flex justify-between">
        <PageHeader
          title={"Survey"}
          description={"Create and Edit Survey"}
        />
        <AppButton buttontext={"Add"} onClick={() => navigate("/survey/add")} />
      </div>
      <div className="p-6 space-y-8">
        {SurveyData?.selectedSurvey?.map((group, groupIndex) => (
          <div key={group._id || groupIndex}>
            <h2 className="text-xl font-semibold mb-4">
              Question Group {groupIndex + 1}
            </h2>
            <table className="w-full border-collapse rounded-lg overflow-hidden shadow-md">
              <thead>
                <tr className="bg-black text-white">
                  <th className="px-6 py-3 text-left">#</th>
                  <th className="px-6 py-3 text-left">Question</th>
                  {/* Right aligned actions */}
                  <th className="px-6 py-3 text-right">
                    <div className="flex items-center justify-end gap-4">
                      {
                        loading === group?._id ?
                          <Loader />
                          :
                          <SelectedQuestion
                            groupIndex={groupIndex}
                            isActive={group?.selected}
                            onToggle={() => handleToggle(groupIndex, group._id, group?.selected)}
                          />
                      }
                      <PenLine
                        className="cursor-pointer"
                        onClick={() => navigate(`/survey/add/${group._id}`)}
                      />
                      <Trash className="cursor-pointer" onClick={() => handelDelete(group._id)} />

                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(group.questions) ? (
                  group.questions.map((item, index) => (
                    <tr
                      key={`${groupIndex}-${index}`}
                      className={`${index % 2 === 0 ? "bg-gray-50" : "bg-white"
                        } hover:bg-gray-200 transition`}
                    >
                      <td className="px-6 py-3 font-medium">{index + 1}</td>
                      <td className="px-6 py-3">{item.question}</td>
                    </tr>
                  ))
                ) : (
                  <tr className="bg-gray-50">
                    <td className="px-6 py-3 font-medium">1</td>
                    <td className="px-6 py-3">{group.questions}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ))}
      </div>

    </div>
  );
};

export default Survey;
